import { 
  IDENTIFY_USER_REQUEST, IDENTIFING_USER_SUCCEEDED, IDENTIFING_USER_FAILED,
  SUBMIT_CONTACT_FORM_REQUEST, SUBMITTING_CONTACT_FORM_SUCCEEDED, SUBMITTING_CONTACT_FORM_FAILED,
  RECORD_QUIZ_RESULT_REQUEST, RECORDING_QUIZ_RESULT_SUCCEEDED, RECORDING_QUIZ_RESULT_FAILED
} from 'constants/actionTypes.jsx';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';

const apiUrl = `${process.env.REACT_APP_API_URL}/api/2.0`;
const IDENTITY_URL = `${apiUrl}/resource_center/identity`;
const WIDGET_URL = `${apiUrl}/widgets`;
const QUIZ_URL = "https://r2jzfv9sce.execute-api.us-east-1.amazonaws.com/prod/quiz";

/**
 *  Identify user from request
 */
export const identifyUser = createAction(IDENTIFY_USER_REQUEST);
const identifingUserSucceeded = createAction(IDENTIFING_USER_SUCCEEDED);
const identifingUserFailed = createAction(IDENTIFING_USER_FAILED);

function* identifyUserSaga(action) {
  const id = action.payload;
  const url = `${IDENTITY_URL}?appId=${id}`;

  const identityAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(identityAPI);
    yield put(identifingUserSucceeded(response));
  } catch (error) {
    yield put(identifingUserFailed(error));
  }
}

/**
* Submit contact form
*/
export const submitContactForm = createAction(SUBMIT_CONTACT_FORM_REQUEST, (appId, id, request) => {
  return {
    appId: appId,
    id: id,
    request: request
  }
});

const submittingContactFormSuccedded = createAction(SUBMITTING_CONTACT_FORM_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const submittingContactFormFailed = createAction(SUBMITTING_CONTACT_FORM_FAILED, (error) => {
  return {
    error: error
  }
});

function* submitContactFormSaga(action) {
  var {appId, id, request} = action.payload;

  let url = buildUrl(WIDGET_URL, {
    path: `/${id}/form?appId=${appId}`
  });

  const submitContactFormAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(submitContactFormAPI);
    yield put(submittingContactFormSuccedded(response));
  } catch (error) {
    console.log(error);
    var data = _.get(error, 'response.data', {message: "Unable to submit form"});
    yield put(submittingContactFormFailed(data));
  }
}

/**
* Submit quiz result
*/
export const recordQuizResult = createAction(RECORD_QUIZ_RESULT_REQUEST, (request) => {
  return {
    request: request
  }
});

const recordingQuizResultSuccedded = createAction(RECORDING_QUIZ_RESULT_SUCCEEDED, (response) => {
  return {
    response: response
  }
});

const recordingQuizResultFailed = createAction(RECORDING_QUIZ_RESULT_FAILED, (error) => {
  return {
    error: error
  }
});

function* recordQuizResultSaga(action) {
  var {request} = action.payload;

  const recordQuizResultAPI = () => {
    return axios.post(QUIZ_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(recordQuizResultAPI);
    yield put(recordingQuizResultSuccedded(response));
  } catch (error) {
    console.log(error);
    yield put(recordingQuizResultFailed(error));
  }
}

export default function* root() {
  yield takeEvery(IDENTIFY_USER_REQUEST, identifyUserSaga);
  yield takeEvery(SUBMIT_CONTACT_FORM_REQUEST, submitContactFormSaga);
  yield takeEvery(RECORD_QUIZ_RESULT_REQUEST, recordQuizResultSaga);
}